export const BASE_URL = 'https://sociohub.netlify.app/profile'